function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M333.467-32.902c1.191-1.992 2.352-3.932 4.819-5.115 4.259-2.023 9.702-.822 12.161 2.68 2.768 3.984.578 6.673-1.708 9.479-1.596 1.959-3.238 3.975-3.273 6.53-.095 2.49 1.525 4.437 3.134 6.371 1.551 1.865 3.092 3.717 3.077 6.033-.031 2.274-1.532 4.085-3.048 5.915-1.59 1.918-3.197 3.857-3.141 6.372-.088 3.762 4.928 6.18 8.879 4.271 2.662-1.023 3.962-3.258 5.247-5.466 1.189-2.044 2.366-4.066 4.596-5.087 4.26-2.022 9.703-.821 12.162 2.68 2.459 3.502.998 7.981-3.259 10.004-2.192 1.077-4.905.904-7.648.729-2.967-.19-5.969-.38-8.382 1.006-2.809 1.385-4.2 3.709-5.584 6.02-.523.875-1.045 1.747-1.642 2.566-3.482 4.213-11.829 3.773-14.779-.714-2.73-3.93-.528-6.603 1.751-9.37 1.644-1.995 3.328-4.04 3.23-6.639-.003-2.485-1.59-4.419-3.159-6.33-1.543-1.878-3.067-3.735-3.051-6.073.03-2.245 1.567-4.063 3.103-5.881 1.655-1.958 3.31-3.916 3.086-6.407-.275-3.853-4.855-6.052-8.879-4.271-2.662 1.023-3.962 3.258-5.248 5.466-1.189 2.044-2.365 4.066-4.596 5.087-4.259 2.022-9.702.821-12.161-2.68-2.459-3.502-.999-7.981 3.258-10.004 2.192-1.077 4.906-.904 7.649-.729 2.967.19 5.968.38 8.381-1.006 2.605-1.39 3.83-3.44 5.025-5.437z",
  fill: "url(#upx-banner_svg__paint0_linear_14813_51300)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M908.706-32.901c1.191-1.992 2.352-3.932 4.818-5.116 4.26-2.023 9.703-.822 12.162 2.68 2.767 3.984.578 6.673-1.708 9.479-1.596 1.96-3.238 3.976-3.273 6.53-.096 2.49 1.524 4.437 3.134 6.371 1.551 1.865 3.092 3.717 3.077 6.033-.031 2.274-1.532 4.086-3.048 5.915-1.59 1.919-3.197 3.857-3.141 6.372-.088 3.762 4.927 6.18 8.878 4.272 2.662-1.024 3.963-3.258 5.248-5.467 1.189-2.044 2.366-4.065 4.596-5.086 4.26-2.023 9.702-.822 12.162 2.68 2.459 3.501.998 7.98-3.259 10.003-2.192 1.077-4.906.904-7.649.73-2.967-.19-5.968-.382-8.381 1.005-2.809 1.385-4.2 3.71-5.584 6.021-.523.874-1.045 1.746-1.642 2.565-3.482 4.213-11.829 3.774-14.779-.713-2.73-3.931-.528-6.604 1.751-9.37 1.644-1.996 3.328-4.04 3.23-6.64-.003-2.485-1.591-4.418-3.159-6.33-1.543-1.878-3.067-3.735-3.052-6.073.031-2.245 1.567-4.062 3.104-5.88 1.655-1.959 3.31-3.917 3.085-6.408-.274-3.853-4.855-6.052-8.878-4.27-2.662 1.023-3.963 3.257-5.248 5.466-1.189 2.043-2.366 4.065-4.596 5.086-4.26 2.022-9.702.821-12.162-2.68-2.459-3.502-.998-7.98 3.259-10.004 2.192-1.077 4.906-.904 7.649-.729 2.967.19 5.968.381 8.381-1.005 2.605-1.391 3.83-3.44 5.025-5.438z",
  fill: "url(#upx-banner_svg__paint1_linear_14813_51300)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M716.882-24.901c1.191-1.992 2.352-3.933 4.819-5.116 4.259-2.023 9.702-.822 12.161 2.68 2.768 3.984.578 6.673-1.708 9.479-1.596 1.96-3.238 3.976-3.273 6.53-.095 2.49 1.525 4.437 3.134 6.371 1.551 1.865 3.092 3.717 3.077 6.033-.031 2.274-1.532 4.085-3.048 5.915-1.59 1.919-3.197 3.857-3.141 6.372-.088 3.762 4.928 6.18 8.878 4.271 2.662-1.023 3.963-3.257 5.248-5.466 1.189-2.044 2.366-4.065 4.596-5.086 4.26-2.023 9.703-.822 12.162 2.68 2.459 3.502.998 7.98-3.259 10.003-2.192 1.077-4.906.904-7.649.73-2.967-.19-5.968-.382-8.381 1.005-2.809 1.385-4.2 3.71-5.584 6.021-.523.874-1.045 1.746-1.642 2.565-3.482 4.213-11.829 3.773-14.779-.713-2.73-3.931-.528-6.604 1.751-9.37 1.644-1.996 3.328-4.04 3.23-6.64-.003-2.485-1.591-4.418-3.159-6.33-1.543-1.878-3.067-3.735-3.052-6.073.031-2.245 1.567-4.063 3.104-5.88 1.655-1.959 3.31-3.917 3.085-6.408-.274-3.853-4.854-6.052-8.878-4.27-2.662 1.023-3.963 3.257-5.248 5.466-1.189 2.043-2.366 4.065-4.596 5.086-4.259 2.022-9.702.821-12.161-2.68-2.46-3.502-.999-7.98 3.258-10.004 2.192-1.077 4.906-.904 7.649-.729 2.967.19 5.968.381 8.381-1.005 2.605-1.391 3.83-3.44 5.025-5.438z",
  fill: "url(#upx-banner_svg__paint2_linear_14813_51300)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M597.824 56.006c.572 2.377 1.129 4.692 3.324 6.514 3.797 3.123 9.948 3.121 13.744 0 4.286-3.557 2.9-6.9 1.454-10.391-1.01-2.437-2.049-4.945-1.209-7.647.755-2.648 3.132-4.324 5.492-5.99 2.277-1.605 4.538-3.2 5.317-5.645.748-2.406-.212-4.664-1.183-6.946-1.018-2.392-2.046-4.81-1.124-7.45 1.2-3.986 7.319-5.37 10.829-2.44 2.456 1.7 3.059 4.357 3.656 6.985.552 2.431 1.099 4.837 3.1 6.432 3.797 3.122 9.949 3.121 13.744 0 3.795-3.12 3.794-8.182-.001-11.305-1.941-1.645-4.862-2.094-7.814-2.547-3.194-.49-6.424-.986-8.493-3.008-2.486-2.114-3.155-4.888-3.82-7.647v-.002c-.252-1.042-.503-2.083-.851-3.085-2.225-5.252-11.177-6.728-15.828-2.683-4.229 3.51-2.825 6.84-1.372 10.287 1.049 2.487 2.122 5.034 1.127 7.752-.858 2.62-3.195 4.29-5.506 5.94-2.271 1.622-4.516 3.226-5.303 5.695-.739 2.374.257 4.648 1.253 6.922 1.073 2.45 2.145 4.899 1.053 7.473-1.613 4-7.197 5.253-10.829 2.44-2.455-1.698-3.059-4.356-3.656-6.984-.552-2.431-1.098-4.837-3.099-6.431-3.797-3.123-9.949-3.122-13.744-.002-3.796 3.121-3.794 8.183 0 11.306 1.942 1.645 4.863 2.093 7.815 2.547 3.194.49 6.424.986 8.492 3.008 2.269 2.072 2.858 4.518 3.432 6.902z",
  fill: "url(#upx-banner_svg__paint3_linear_14813_51300)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M651.084 63.99c.572 2.377 1.13 4.693 3.324 6.514 3.797 3.123 9.949 3.122 13.744.001 4.287-3.557 2.901-6.902 1.454-10.392-1.01-2.437-2.049-4.945-1.208-7.646.754-2.648 3.131-4.325 5.492-5.99 2.276-1.606 4.537-3.2 5.316-5.646.749-2.405-.212-4.664-1.183-6.945-1.017-2.393-2.046-4.811-1.123-7.45 1.199-3.986 7.318-5.37 10.829-2.44 2.455 1.699 3.059 4.357 3.656 6.985.552 2.43 1.098 4.836 3.099 6.43 3.797 3.124 9.949 3.122 13.744.002 3.796-3.12 3.794-8.183 0-11.305-1.942-1.646-4.863-2.094-7.815-2.547-3.194-.49-6.424-.986-8.492-3.009-2.487-2.113-3.155-4.887-3.821-7.647v-.002c-.251-1.042-.502-2.083-.851-3.084-2.224-5.252-11.176-6.729-15.828-2.683-4.228 3.51-2.824 6.84-1.371 10.287 1.048 2.486 2.122 5.033 1.126 7.751-.857 2.62-3.195 4.29-5.505 5.94-2.272 1.622-4.517 3.226-5.304 5.695-.738 2.374.258 4.648 1.254 6.923 1.072 2.449 2.145 4.898 1.053 7.473-1.613 3.999-7.198 5.253-10.829 2.44-2.456-1.699-3.059-4.357-3.656-6.985-.552-2.43-1.099-4.836-3.1-6.431-3.797-3.123-9.949-3.122-13.744-.001-3.795 3.12-3.794 8.183.001 11.305 1.941 1.646 4.862 2.094 7.814 2.547 3.194.49 6.425.986 8.493 3.009 2.268 2.072 2.857 4.517 3.431 6.9z",
  fill: "url(#upx-banner_svg__paint4_linear_14813_51300)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M691.396 76.908c-.794-2.48.131-4.715 1.08-7.01.952-2.3 1.928-4.66 1.222-7.387-.561-2.603-3.058-4.361-5.526-6.1-2.281-1.606-4.538-3.196-5.22-5.42-1.388-4.265 1.687-8.65 6.87-9.79 5.184-1.142 10.512 1.388 11.902 5.654.764 2.205-.224 4.512-1.224 6.845-1.08 2.521-2.172 5.072-1.078 7.552 1.435 3.93 7.034 5.142 10.861 2.342 2.51-1.78 3.07-4.343 3.629-6.905.52-2.38 1.04-4.758 3.122-6.51 2.182-1.815 5.101-2.28 8.054-2.751 3.004-.479 6.043-.963 8.377-2.88 2.515-1.944 3.133-4.591 3.736-7.175.836-3.583 1.644-7.045 7.439-8.345 6.487-1.59 13.342 3.37 12.077 8.834-.307 1.012-.722 2.016-1.138 3.023-1.101 2.663-2.208 5.341-1.339 8.195.562 2.602 3.058 4.36 5.526 6.099 2.281 1.607 4.539 3.196 5.22 5.42 1.389 4.265-1.686 8.65-6.87 9.79-5.183 1.142-10.512-1.387-11.902-5.654-.764-2.204.225-4.512 1.224-6.845 1.08-2.521 2.173-5.071 1.078-7.552-1.259-3.983-7.399-5.3-10.86-2.342-2.403 1.906-2.982 4.423-3.555 6.914-.546 2.375-1.086 4.726-3.197 6.502-2.16 1.797-5.088 2.248-8.034 2.702-3.057.47-6.134.945-8.397 2.928-2.37 1.994-2.994 4.593-3.6 7.119-.869 3.618-1.701 7.084-7.575 8.402-5.183 1.14-10.512-1.389-11.902-5.655z",
  fill: "url(#upx-banner_svg__paint5_linear_14813_51300)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M792.97 54.52c-2.195-1.822-2.752-4.137-3.325-6.514-.573-2.384-1.162-4.83-3.431-6.902-2.068-2.023-5.299-2.518-8.492-3.008-2.953-.453-5.873-.902-7.815-2.547-3.794-3.123-3.796-8.185-.001-11.305 3.796-3.121 9.948-3.122 13.745 0 2.001 1.596 2.547 4 3.099 6.432.597 2.628 1.201 5.286 3.656 6.984 3.631 2.813 9.216 1.56 10.829-2.44 1.092-2.574.019-5.024-1.053-7.473-.996-2.274-1.992-4.548-1.253-6.922.786-2.47 3.032-4.073 5.303-5.695 2.31-1.65 4.648-3.32 5.505-5.94.996-2.719-.078-5.265-1.126-7.752-1.453-3.446-2.857-6.777 1.372-10.287 4.651-4.045 13.603-2.569 15.828 2.683.348 1.002.599 2.043.85 3.085l.001.002c.665 2.76 1.334 5.533 3.82 7.647 2.068 2.022 5.299 2.518 8.492 3.008 2.953.454 5.874.902 7.815 2.547 3.795 3.123 3.796 8.185.001 11.305-3.796 3.121-9.947 3.122-13.744 0-2.001-1.596-2.548-4-3.1-6.432-.597-2.628-1.2-5.286-3.656-6.984-3.51-2.931-9.629-1.547-10.829 2.44-.922 2.639.106 5.056 1.124 7.45.97 2.28 1.931 4.54 1.182 6.945-.778 2.445-3.04 4.04-5.316 5.645-2.361 1.666-4.737 3.342-5.492 5.99-.84 2.702.199 5.21 1.209 7.647 1.446 3.49 2.832 6.834-1.454 10.392-3.796 3.12-9.947 3.122-13.744-.001z",
  fill: "url(#upx-banner_svg__paint6_linear_14813_51300)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M842.908 55.99c.572 2.377 1.129 4.693 3.324 6.514 3.797 3.123 9.949 3.122 13.744.001 4.286-3.558 2.901-6.902 1.454-10.392-1.01-2.437-2.049-4.945-1.209-7.646.755-2.648 3.132-4.325 5.493-5.99 2.276-1.606 4.537-3.2 5.316-5.646.749-2.405-.212-4.664-1.183-6.945-1.017-2.393-2.046-4.811-1.123-7.45 1.199-3.986 7.318-5.37 10.829-2.44 2.455 1.699 3.059 4.357 3.656 6.984.552 2.432 1.098 4.837 3.099 6.432 3.797 3.123 9.949 3.121 13.744 0 3.796-3.12 3.794-8.182 0-11.304-1.942-1.646-4.863-2.094-7.815-2.547-3.194-.49-6.424-.986-8.492-3.009-2.487-2.114-3.155-4.887-3.821-7.647v-.001c-.252-1.043-.502-2.083-.851-3.085-2.225-5.252-11.177-6.729-15.828-2.683-4.229 3.51-2.824 6.84-1.371 10.287 1.048 2.486 2.122 5.033 1.126 7.751-.858 2.62-3.195 4.29-5.506 5.94-2.271 1.622-4.516 3.226-5.303 5.695-.738 2.374.257 4.648 1.253 6.923 1.073 2.449 2.145 4.898 1.053 7.473-1.612 3.999-7.197 5.253-10.828 2.44-2.456-1.699-3.06-4.357-3.656-6.985-.553-2.43-1.099-4.836-3.1-6.431-3.797-3.123-9.949-3.122-13.744-.001-3.795 3.12-3.794 8.183.001 11.305 1.941 1.646 4.862 2.094 7.814 2.547 3.194.49 6.425.986 8.493 3.009 2.268 2.072 2.857 4.517 3.431 6.9z",
  fill: "url(#upx-banner_svg__paint7_linear_14813_51300)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M883.22 68.908c-.794-2.48.131-4.715 1.08-7.01.951-2.3 1.928-4.66 1.222-7.387-.561-2.603-3.058-4.361-5.526-6.1-2.281-1.606-4.538-3.196-5.22-5.42-1.388-4.265 1.687-8.65 6.87-9.79 5.184-1.142 10.512 1.388 11.902 5.654.764 2.205-.225 4.512-1.224 6.845-1.08 2.521-2.173 5.072-1.078 7.552 1.435 3.93 7.033 5.142 10.861 2.342 2.51-1.78 3.07-4.343 3.629-6.905.52-2.38 1.04-4.758 3.122-6.51 2.182-1.815 5.101-2.28 8.054-2.751 3.004-.479 6.043-.963 8.377-2.88 2.515-1.944 3.133-4.591 3.736-7.175.836-3.583 1.644-7.045 7.439-8.345 6.487-1.59 13.342 3.37 12.077 8.834-.307 1.012-.722 2.016-1.138 3.023-1.101 2.663-2.208 5.341-1.339 8.195.562 2.602 3.058 4.36 5.526 6.099 2.281 1.607 4.538 3.196 5.22 5.42 1.388 4.265-1.687 8.65-6.87 9.79-5.183 1.142-10.512-1.387-11.902-5.654-.764-2.204.225-4.512 1.224-6.845 1.08-2.521 2.173-5.071 1.078-7.552-1.259-3.983-7.399-5.3-10.861-2.342-2.402 1.906-2.981 4.423-3.554 6.914-.546 2.375-1.086 4.726-3.197 6.502-2.16 1.797-5.088 2.248-8.035 2.702-3.056.47-6.133.945-8.396 2.928-2.37 1.994-2.994 4.593-3.6 7.119-.869 3.618-1.701 7.084-7.575 8.402-5.183 1.14-10.512-1.389-11.902-5.655z",
  fill: "url(#upx-banner_svg__paint8_linear_14813_51300)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M986.227 54.52c-2.195-1.822-2.752-4.137-3.324-6.514-.574-2.384-1.163-4.83-3.431-6.902-2.068-2.023-5.299-2.518-8.493-3.008-2.952-.453-5.873-.902-7.814-2.547-3.795-3.123-3.796-8.185-.001-11.305 3.795-3.121 9.947-3.122 13.744 0 2.001 1.596 2.547 4 3.1 6.432.596 2.628 1.2 5.286 3.656 6.984 3.631 2.813 9.216 1.56 10.828-2.44 1.092-2.574.02-5.024-1.053-7.473-.996-2.274-1.991-4.548-1.253-6.922.787-2.47 3.032-4.073 5.303-5.695 2.311-1.65 4.651-3.32 5.501-5.94 1-2.719-.07-5.265-1.12-7.752-1.45-3.446-2.859-6.777 1.37-10.287 4.65-4.045 13.6-2.569 15.83 2.683.35 1.002.6 2.043.85 3.085v.002c.66 2.76 1.33 5.533 3.82 7.647 2.07 2.022 5.3 2.518 8.49 3.008 2.95.454 5.88.902 7.82 2.547 3.79 3.123 3.79 8.185 0 11.305-3.8 3.121-9.95 3.122-13.75 0-2-1.596-2.54-4-3.1-6.432-.59-2.628-1.2-5.286-3.65-6.984-3.51-2.931-9.63-1.547-10.83 2.44-.92 2.639.1 5.056 1.12 7.45.97 2.28 1.93 4.54 1.18 6.945-.77 2.445-3.04 4.04-5.31 5.645-2.36 1.666-4.74 3.342-5.49 5.99-.844 2.702.2 5.21 1.21 7.647 1.44 3.49 2.83 6.834-1.459 10.392-3.795 3.12-9.947 3.122-13.744-.001z",
  fill: "url(#upx-banner_svg__paint9_linear_14813_51300)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1036.16 55.99c.58 2.377 1.13 4.693 3.33 6.514 3.8 3.123 9.95 3.122 13.74.001 4.29-3.558 2.9-6.902 1.46-10.392-1.01-2.437-2.05-4.945-1.21-7.646.75-2.648 3.13-4.325 5.49-5.99 2.28-1.606 4.54-3.2 5.32-5.646.75-2.405-.22-4.664-1.19-6.945-1.01-2.393-2.04-4.811-1.12-7.45 1.2-3.986 7.32-5.37 10.83-2.44 2.45 1.699 3.06 4.357 3.65 6.984.56 2.432 1.1 4.837 3.1 6.432 3.8 3.123 9.95 3.121 13.75 0 3.79-3.12 3.79-8.182 0-11.304-1.94-1.646-4.86-2.094-7.82-2.547-3.19-.49-6.42-.986-8.49-3.009-2.49-2.114-3.15-4.888-3.82-7.647-.25-1.043-.5-2.084-.85-3.086-2.23-5.252-11.18-6.729-15.83-2.683-4.23 3.51-2.82 6.84-1.37 10.287 1.05 2.486 2.12 5.033 1.13 7.751-.86 2.62-3.2 4.29-5.51 5.94-2.27 1.622-4.52 3.226-5.3 5.695-.74 2.374.25 4.648 1.25 6.923 1.07 2.449 2.15 4.898 1.05 7.473-1.61 3.999-7.19 5.253-10.83 2.44-2.45-1.699-3.05-4.357-3.65-6.985-.55-2.43-1.1-4.836-3.1-6.431-3.8-3.123-9.95-3.122-13.74-.001-3.8 3.12-3.8 8.183 0 11.305 1.94 1.646 4.86 2.094 7.81 2.547 3.19.49 6.42.986 8.49 3.009 2.27 2.072 2.86 4.517 3.43 6.901z",
  fill: "url(#upx-banner_svg__paint10_linear_14813_51300)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1076.48 68.908c-.8-2.48.13-4.715 1.08-7.01.95-2.3 1.92-4.66 1.22-7.387-.56-2.603-3.06-4.361-5.53-6.1-2.28-1.606-4.54-3.196-5.22-5.42-1.39-4.265 1.69-8.65 6.87-9.79 5.19-1.142 10.51 1.388 11.9 5.654.77 2.205-.22 4.512-1.22 6.845-1.08 2.521-2.17 5.072-1.08 7.552 1.44 3.93 7.04 5.142 10.86 2.342 2.51-1.78 3.07-4.343 3.63-6.905.52-2.38 1.04-4.758 3.12-6.51 2.19-1.815 5.11-2.28 8.06-2.751 3-.479 6.04-.963 8.38-2.88 2.51-1.944 3.13-4.591 3.73-7.175.84-3.583 1.65-7.045 7.44-8.345 6.49-1.59 13.34 3.37 12.08 8.834-.31 1.011-.72 2.015-1.14 3.02v.004c-1.1 2.663-2.21 5.34-1.34 8.194.56 2.602 3.06 4.36 5.53 6.099 2.28 1.606 4.53 3.196 5.22 5.42 1.38 4.265-1.69 8.65-6.87 9.79-5.19 1.142-10.52-1.387-11.91-5.654-.76-2.204.23-4.512 1.23-6.845 1.08-2.521 2.17-5.071 1.08-7.552-1.26-3.983-7.4-5.3-10.86-2.342-2.41 1.906-2.99 4.423-3.56 6.914-.54 2.375-1.08 4.726-3.2 6.502-2.16 1.797-5.08 2.248-8.03 2.702-3.06.47-6.13.945-8.4 2.928-2.37 1.994-2.99 4.593-3.6 7.119-.87 3.618-1.7 7.084-7.57 8.402-5.19 1.14-10.51-1.389-11.9-5.655z",
  fill: "url(#upx-banner_svg__paint11_linear_14813_51300)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1101.96-32.901c1.19-1.992 2.35-3.932 4.82-5.116 4.26-2.023 9.7-.822 12.16 2.68 2.77 3.984.58 6.673-1.71 9.479-1.59 1.96-3.23 3.976-3.27 6.53-.09 2.49 1.53 4.437 3.13 6.371 1.56 1.865 3.1 3.717 3.08 6.033-.03 2.274-1.53 4.086-3.05 5.915-1.59 1.919-3.19 3.857-3.14 6.372-.08 3.762 4.93 6.18 8.88 4.272 2.66-1.024 3.96-3.258 5.25-5.467 1.19-2.044 2.37-4.065 4.6-5.086 4.25-2.023 9.7-.822 12.16 2.68 2.46 3.501 1 7.98-3.26 10.003-2.19 1.077-4.91.904-7.65.73-2.97-.19-5.97-.382-8.38 1.005-2.81 1.385-4.2 3.71-5.59 6.021v.002c-.52.873-1.04 1.744-1.64 2.563-3.48 4.213-11.83 3.774-14.78-.713-2.73-3.931-.52-6.604 1.75-9.37 1.65-1.996 3.33-4.04 3.23-6.64 0-2.485-1.59-4.418-3.15-6.33-1.55-1.878-3.07-3.735-3.06-6.073.03-2.245 1.57-4.062 3.11-5.88 1.65-1.959 3.31-3.917 3.08-6.408-.27-3.853-4.85-6.052-8.88-4.27-2.66 1.023-3.96 3.257-5.24 5.466-1.19 2.043-2.37 4.065-4.6 5.086-4.26 2.022-9.7.821-12.16-2.68-2.46-3.502-1-7.98 3.26-10.004 2.19-1.077 4.9-.904 7.65-.729 2.96.19 5.96.381 8.38-1.005 2.6-1.391 3.83-3.44 5.02-5.438z",
  fill: "url(#upx-banner_svg__paint12_linear_14813_51300)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M1178.49 62.52c-2.2-1.822-2.75-4.137-3.33-6.514-.57-2.384-1.16-4.83-3.43-6.902-2.07-2.023-5.3-2.518-8.49-3.008-2.95-.453-5.87-.902-7.81-2.547-3.8-3.123-3.8-8.185-.01-11.306 3.8-3.12 9.95-3.121 13.75.002 2 1.595 2.55 4 3.1 6.43.59 2.629 1.2 5.287 3.65 6.985 3.64 2.813 9.22 1.56 10.83-2.44 1.09-2.574.02-5.024-1.05-7.473-1-2.274-1.99-4.548-1.25-6.922.78-2.47 3.03-4.073 5.3-5.695 2.31-1.65 4.65-3.32 5.51-5.94.99-2.719-.08-5.265-1.13-7.752-1.45-3.447-2.86-6.777 1.37-10.287 4.65-4.045 13.6-2.569 15.83 2.683.35 1.003.6 2.044.85 3.087.66 2.76 1.33 5.533 3.82 7.647 2.07 2.023 5.3 2.518 8.49 3.008 2.95.453 5.88.902 7.82 2.547 3.79 3.123 3.79 8.185 0 11.305-3.8 3.121-9.95 3.122-13.75 0-2-1.596-2.54-4-3.1-6.432-.59-2.628-1.2-5.286-3.65-6.984-3.51-2.931-9.63-1.547-10.83 2.44-.92 2.639.1 5.056 1.12 7.45.97 2.28 1.93 4.54 1.19 6.945-.78 2.445-3.04 4.04-5.32 5.645-2.36 1.666-4.74 3.342-5.49 5.99-.84 2.702.2 5.21 1.21 7.647 1.44 3.49 2.83 6.834-1.46 10.392-3.79 3.12-9.95 3.122-13.74-.001z",
  fill: "url(#upx-banner_svg__paint13_linear_14813_51300)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M1228.42 63.99c.58 2.377 1.13 4.693 3.33 6.514 3.8 3.123 9.95 3.122 13.74.001 4.29-3.557 2.9-6.901 1.46-10.392-1.01-2.437-2.05-4.945-1.21-7.646.75-2.648 3.13-4.325 5.49-5.99 2.28-1.606 4.54-3.2 5.32-5.646.75-2.405-.22-4.664-1.19-6.945-1.01-2.393-2.04-4.811-1.12-7.45 1.2-3.986 7.32-5.37 10.83-2.44 2.45 1.699 3.06 4.357 3.66 6.985.55 2.43 1.09 4.836 3.1 6.43 3.79 3.124 9.94 3.122 13.74.002 3.79-3.12 3.79-8.183 0-11.305-1.94-1.646-4.86-2.094-7.82-2.547-3.19-.49-6.42-.986-8.49-3.009-2.48-2.113-3.15-4.887-3.82-7.647-.25-1.043-.5-2.084-.85-3.086-2.22-5.252-11.18-6.729-15.83-2.683-4.23 3.51-2.82 6.84-1.37 10.287 1.05 2.486 2.12 5.033 1.13 7.751-.86 2.62-3.2 4.29-5.51 5.94-2.27 1.622-4.52 3.226-5.3 5.695-.74 2.374.26 4.648 1.25 6.923 1.07 2.449 2.15 4.898 1.05 7.473-1.61 3.999-7.19 5.253-10.82 2.44-2.46-1.699-3.06-4.357-3.66-6.985-.55-2.43-1.1-4.836-3.1-6.431-3.8-3.123-9.95-3.122-13.74-.001-3.8 3.12-3.8 8.183 0 11.305 1.94 1.646 4.86 2.094 7.81 2.547 3.19.49 6.43.986 8.49 3.009 2.27 2.072 2.86 4.517 3.43 6.901z",
  fill: "url(#upx-banner_svg__paint14_linear_14813_51300)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1268.74 76.908c-.8-2.48.13-4.715 1.08-7.01.95-2.3 1.92-4.66 1.22-7.387-.56-2.603-3.06-4.361-5.53-6.1-2.28-1.606-4.54-3.196-5.22-5.42-1.39-4.265 1.69-8.65 6.87-9.79 5.19-1.142 10.51 1.388 11.9 5.654.77 2.205-.22 4.512-1.22 6.845-1.08 2.521-2.17 5.072-1.08 7.552 1.44 3.93 7.04 5.142 10.86 2.342 2.51-1.78 3.07-4.343 3.63-6.905.52-2.38 1.04-4.758 3.12-6.51 2.19-1.815 5.11-2.28 8.06-2.751 3-.479 6.04-.963 8.38-2.88 2.51-1.944 3.13-4.591 3.73-7.175.84-3.583 1.65-7.045 7.44-8.345 6.49-1.59 13.34 3.37 12.08 8.834-.31 1.011-.72 2.015-1.14 3.02v.004c-1.1 2.663-2.21 5.34-1.34 8.194.56 2.602 3.06 4.36 5.53 6.099 2.28 1.606 4.53 3.196 5.22 5.42 1.38 4.265-1.69 8.65-6.87 9.79-5.19 1.142-10.52-1.387-11.91-5.654-.76-2.204.23-4.512 1.23-6.845 1.08-2.521 2.17-5.071 1.08-7.552-1.26-3.983-7.4-5.3-10.86-2.342-2.41 1.906-2.99 4.423-3.56 6.914-.54 2.375-1.08 4.726-3.2 6.502-2.16 1.797-5.08 2.248-8.03 2.702-3.06.47-6.13.945-8.4 2.928-2.37 1.994-2.99 4.593-3.6 7.119-.87 3.618-1.7 7.084-7.57 8.402-5.19 1.14-10.51-1.389-11.9-5.655z",
  fill: "url(#upx-banner_svg__paint15_linear_14813_51300)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1294.22-24.901c1.19-1.992 2.35-3.933 4.82-5.116 4.26-2.023 9.7-.822 12.16 2.68 2.77 3.984.58 6.673-1.71 9.479-1.59 1.96-3.23 3.976-3.27 6.53-.09 2.49 1.53 4.437 3.13 6.371 1.56 1.865 3.1 3.717 3.08 6.033-.03 2.274-1.53 4.086-3.05 5.915-1.59 1.919-3.19 3.857-3.14 6.372-.08 3.762 4.93 6.18 8.88 4.271 2.66-1.023 3.96-3.257 5.25-5.466 1.19-2.044 2.36-4.065 4.6-5.086 4.25-2.023 9.7-.822 12.16 2.68 2.46 3.502 1 7.98-3.26 10.003-2.19 1.077-4.91.904-7.65.73-2.97-.19-5.97-.382-8.38 1.005-2.81 1.385-4.2 3.71-5.59 6.021v.002c-.52.873-1.04 1.744-1.64 2.563-3.48 4.213-11.83 3.773-14.78-.713-2.73-3.931-.52-6.604 1.75-9.37 1.65-1.996 3.33-4.04 3.23-6.64 0-2.485-1.59-4.418-3.16-6.33-1.54-1.878-3.06-3.735-3.05-6.073.03-2.245 1.57-4.063 3.11-5.88 1.65-1.959 3.31-3.917 3.08-6.408-.27-3.853-4.85-6.052-8.88-4.27-2.66 1.023-3.96 3.257-5.24 5.466-1.19 2.043-2.37 4.065-4.6 5.086-4.26 2.022-9.7.821-12.16-2.68-2.46-3.502-1-7.98 3.26-10.004 2.19-1.077 4.9-.904 7.65-.729 2.96.19 5.96.381 8.38-1.005 2.6-1.391 3.83-3.44 5.02-5.438z",
  fill: "url(#upx-banner_svg__paint16_linear_14813_51300)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1370.31 54.52c-2.19-1.822-2.75-4.137-3.32-6.514-.58-2.384-1.17-4.83-3.44-6.902-2.06-2.023-5.29-2.518-8.49-3.008-2.95-.453-5.87-.902-7.81-2.547-3.8-3.123-3.8-8.185 0-11.305 3.79-3.121 9.94-3.122 13.74 0 2 1.596 2.55 4 3.1 6.432.6 2.628 1.2 5.286 3.66 6.984 3.63 2.813 9.21 1.56 10.83-2.44 1.09-2.574.02-5.024-1.06-7.473-.99-2.274-1.99-4.548-1.25-6.922.79-2.47 3.03-4.073 5.3-5.695 2.31-1.65 4.65-3.32 5.51-5.94.99-2.719-.08-5.265-1.13-7.752-1.45-3.447-2.86-6.777 1.37-10.287 4.65-4.045 13.61-2.569 15.83 2.683.35 1.003.6 2.044.85 3.087.67 2.76 1.34 5.533 3.82 7.647 2.07 2.022 5.3 2.518 8.5 3.008 2.95.454 5.87.902 7.81 2.547 3.79 3.123 3.8 8.185 0 11.305-3.79 3.121-9.95 3.122-13.74 0-2-1.596-2.55-4-3.1-6.432-.6-2.628-1.2-5.286-3.66-6.984-3.51-2.931-9.63-1.547-10.83 2.44-.92 2.639.11 5.056 1.13 7.45.97 2.28 1.93 4.54 1.18 6.945-.78 2.445-3.04 4.04-5.32 5.645-2.36 1.666-4.74 3.342-5.49 5.99-.84 2.702.2 5.21 1.21 7.647 1.44 3.49 2.83 6.834-1.46 10.392-3.79 3.12-9.94 3.122-13.74-.001z",
  fill: "url(#upx-banner_svg__paint17_linear_14813_51300)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M1420.25 55.99c.57 2.377 1.13 4.693 3.32 6.514 3.8 3.123 9.95 3.122 13.75.001 4.28-3.558 2.9-6.902 1.45-10.392-1.01-2.437-2.05-4.945-1.21-7.646.76-2.648 3.13-4.325 5.49-5.99 2.28-1.606 4.54-3.2 5.32-5.646.75-2.405-.21-4.664-1.18-6.945-1.02-2.393-2.05-4.811-1.13-7.45 1.2-3.986 7.32-5.37 10.83-2.44 2.46 1.699 3.06 4.357 3.66 6.984.55 2.432 1.1 4.837 3.1 6.432 3.79 3.123 9.95 3.121 13.74 0 3.8-3.12 3.8-8.182 0-11.304-1.94-1.646-4.86-2.094-7.81-2.547-3.2-.49-6.43-.986-8.5-3.009-2.48-2.114-3.15-4.888-3.82-7.647-.25-1.043-.5-2.084-.85-3.086-2.22-5.252-11.17-6.729-15.83-2.683-4.22 3.51-2.82 6.84-1.37 10.287 1.05 2.486 2.12 5.033 1.13 7.751-.86 2.62-3.2 4.29-5.51 5.94-2.27 1.622-4.51 3.226-5.3 5.695-.74 2.374.26 4.648 1.25 6.923 1.08 2.449 2.15 4.898 1.06 7.473-1.62 3.999-7.2 5.253-10.83 2.44-2.46-1.699-3.06-4.357-3.66-6.985-.55-2.43-1.1-4.836-3.1-6.431-3.79-3.123-9.95-3.122-13.74-.001-3.8 3.12-3.8 8.183 0 11.305 1.94 1.646 4.86 2.094 7.81 2.547 3.2.49 6.43.986 8.5 3.009 2.26 2.072 2.85 4.517 3.43 6.901z",
  fill: "url(#upx-banner_svg__paint18_linear_14813_51300)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1460.56 68.908c-.79-2.48.13-4.715 1.08-7.01.95-2.3 1.93-4.66 1.22-7.387-.56-2.603-3.06-4.361-5.52-6.1-2.29-1.606-4.54-3.196-5.22-5.42-1.39-4.265 1.68-8.65 6.87-9.79 5.18-1.142 10.51 1.388 11.9 5.654.76 2.205-.23 4.512-1.23 6.845-1.08 2.521-2.17 5.072-1.07 7.552 1.43 3.93 7.03 5.142 10.86 2.342 2.51-1.78 3.07-4.343 3.63-6.905.52-2.38 1.04-4.758 3.12-6.51 2.18-1.815 5.1-2.28 8.05-2.751 3.01-.479 6.04-.963 8.38-2.88 2.51-1.944 3.13-4.591 3.73-7.175.84-3.583 1.65-7.045 7.44-8.345 6.49-1.59 13.35 3.37 12.08 8.834-.31 1.011-.72 2.015-1.14 3.02v.004c-1.1 2.663-2.21 5.34-1.34 8.194.57 2.602 3.06 4.36 5.53 6.099 2.28 1.606 4.54 3.196 5.22 5.42 1.39 4.265-1.69 8.65-6.87 9.79-5.18 1.142-10.51-1.387-11.9-5.654-.77-2.204.22-4.512 1.22-6.845 1.08-2.521 2.17-5.071 1.08-7.552-1.26-3.983-7.4-5.3-10.86-2.342-2.4 1.906-2.98 4.423-3.56 6.914-.54 2.375-1.08 4.726-3.19 6.502-2.16 1.797-5.09 2.248-8.04 2.702-3.05.47-6.13.945-8.39 2.928-2.37 1.994-3 4.593-3.6 7.119-.87 3.618-1.7 7.084-7.58 8.402-5.18 1.14-10.51-1.389-11.9-5.655z",
  fill: "url(#upx-banner_svg__paint19_linear_14813_51300)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M1486.05-32.901c1.19-1.992 2.35-3.932 4.81-5.116 4.26-2.023 9.71-.822 12.17 2.68 2.76 3.984.57 6.673-1.71 9.479-1.6 1.96-3.24 3.976-3.28 6.53-.09 2.49 1.53 4.437 3.14 6.371 1.55 1.865 3.09 3.717 3.07 6.033-.03 2.274-1.53 4.086-3.04 5.915-1.59 1.919-3.2 3.857-3.14 6.372-.09 3.762 4.92 6.18 8.87 4.272 2.67-1.024 3.97-3.258 5.25-5.467 1.19-2.044 2.37-4.065 4.6-5.086 4.26-2.023 9.7-.822 12.16 2.68 2.46 3.501 1 7.98-3.26 10.003-2.19 1.077-4.9.904-7.65.73-2.96-.19-5.97-.382-8.38 1.005-2.81 1.385-4.2 3.71-5.58 6.021v.002c-.53.873-1.05 1.744-1.65 2.563-3.48 4.213-11.82 3.774-14.77-.713-2.73-3.931-.53-6.604 1.75-9.37 1.64-1.996 3.33-4.04 3.23-6.64-.01-2.485-1.59-4.418-3.16-6.33-1.54-1.878-3.07-3.735-3.05-6.073.03-2.245 1.56-4.062 3.1-5.88 1.65-1.959 3.31-3.917 3.09-6.408-.28-3.853-4.86-6.052-8.88-4.27-2.67 1.023-3.97 3.257-5.25 5.466-1.19 2.043-2.37 4.065-4.6 5.086-4.26 2.022-9.7.821-12.16-2.68-2.46-3.502-1-7.98 3.26-10.004 2.19-1.077 4.91-.904 7.65-.729 2.97.19 5.97.381 8.38-1.005 2.6-1.391 3.83-3.44 5.03-5.438z",
  fill: "url(#upx-banner_svg__paint20_linear_14813_51300)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M1563.57 54.52c-2.2-1.822-2.75-4.137-3.33-6.514-.57-2.384-1.16-4.83-3.43-6.902-2.07-2.023-5.3-2.518-8.49-3.008-2.95-.453-5.87-.902-7.82-2.547-3.79-3.123-3.79-8.185 0-11.305 3.8-3.121 9.95-3.122 13.75 0 2 1.596 2.55 4 3.1 6.432.59 2.628 1.2 5.286 3.65 6.984 3.64 2.813 9.22 1.56 10.83-2.44 1.09-2.574.02-5.024-1.05-7.473-1-2.274-1.99-4.548-1.25-6.922.78-2.47 3.03-4.073 5.3-5.695 2.31-1.65 4.65-3.32 5.51-5.94.99-2.719-.08-5.265-1.13-7.752-1.45-3.447-2.86-6.777 1.37-10.287 4.65-4.045 13.6-2.569 15.83 2.683.35 1.003.6 2.044.85 3.087.66 2.76 1.33 5.533 3.82 7.647 2.07 2.022 5.3 2.518 8.49 3.008 2.95.454 5.88.902 7.82 2.547 3.79 3.123 3.79 8.185 0 11.305-3.8 3.121-9.95 3.122-13.75 0-2-1.596-2.54-4-3.1-6.432-.59-2.628-1.2-5.286-3.65-6.984-3.51-2.931-9.63-1.547-10.83 2.44-.92 2.639.1 5.056 1.12 7.45.97 2.28 1.93 4.54 1.19 6.945-.78 2.445-3.04 4.04-5.32 5.645-2.36 1.666-4.74 3.342-5.49 5.99-.84 2.702.2 5.21 1.21 7.647 1.44 3.49 2.83 6.834-1.46 10.392-3.79 3.12-9.95 3.122-13.74-.001z",
  fill: "url(#upx-banner_svg__paint21_linear_14813_51300)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1613.5 55.99c.58 2.377 1.13 4.693 3.33 6.514 3.8 3.123 9.95 3.122 13.74.001 4.29-3.558 2.9-6.902 1.46-10.392-1.01-2.437-2.05-4.945-1.21-7.646.75-2.648 3.13-4.325 5.49-5.99 2.28-1.606 4.54-3.2 5.32-5.646.74-2.405-.22-4.664-1.19-6.945-1.01-2.393-2.04-4.811-1.12-7.45 1.2-3.986 7.32-5.37 10.83-2.44 2.45 1.699 3.06 4.357 3.65 6.984.56 2.432 1.1 4.837 3.1 6.432 3.8 3.123 9.95 3.121 13.75 0 3.79-3.12 3.79-8.182 0-11.304-1.94-1.646-4.86-2.094-7.82-2.547-3.19-.49-6.42-.986-8.49-3.009-2.49-2.114-3.15-4.888-3.82-7.647-.25-1.043-.5-2.084-.85-3.086-2.23-5.252-11.18-6.729-15.83-2.683-4.23 3.51-2.82 6.84-1.37 10.287 1.05 2.486 2.12 5.033 1.13 7.751-.86 2.62-3.2 4.29-5.51 5.94-2.27 1.622-4.52 3.226-5.3 5.695-.74 2.374.25 4.648 1.25 6.923 1.07 2.449 2.15 4.898 1.05 7.473-1.61 3.999-7.19 5.253-10.83 2.44-2.45-1.699-3.05-4.357-3.65-6.985-.55-2.43-1.1-4.836-3.1-6.431-3.8-3.123-9.95-3.122-13.74-.001-3.8 3.12-3.8 8.183 0 11.305 1.94 1.646 4.86 2.094 7.81 2.547 3.19.49 6.42.986 8.49 3.009 2.27 2.072 2.86 4.517 3.43 6.901z",
  fill: "url(#upx-banner_svg__paint22_linear_14813_51300)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M1653.82 68.908c-.8-2.48.13-4.715 1.08-7.01.95-2.3 1.92-4.66 1.22-7.387-.56-2.603-3.06-4.361-5.53-6.1-2.28-1.606-4.54-3.196-5.22-5.42-1.39-4.265 1.69-8.65 6.87-9.79 5.19-1.142 10.51 1.388 11.91 5.654.76 2.205-.23 4.512-1.23 6.845-1.08 2.521-2.17 5.072-1.08 7.552 1.44 3.93 7.04 5.142 10.86 2.342 2.51-1.78 3.07-4.343 3.63-6.905.52-2.38 1.04-4.758 3.12-6.51 2.19-1.815 5.11-2.28 8.06-2.751 3-.479 6.04-.963 8.38-2.88 2.51-1.944 3.13-4.591 3.73-7.175.84-3.583 1.65-7.045 7.44-8.345 6.49-1.59 13.34 3.37 12.08 8.834-.31 1.011-.72 2.015-1.14 3.02v.004c-1.1 2.663-2.21 5.34-1.34 8.194.56 2.602 3.06 4.36 5.53 6.099 2.28 1.606 4.54 3.196 5.22 5.42 1.39 4.265-1.69 8.65-6.87 9.79-5.19 1.142-10.52-1.387-11.91-5.654-.76-2.204.23-4.512 1.23-6.845 1.08-2.521 2.17-5.071 1.08-7.552-1.26-3.983-7.4-5.3-10.86-2.342-2.41 1.906-2.99 4.423-3.56 6.914-.54 2.375-1.08 4.726-3.19 6.502-2.17 1.797-5.09 2.248-8.04 2.702-3.06.47-6.13.945-8.4 2.928-2.37 1.994-2.99 4.593-3.6 7.119-.87 3.618-1.7 7.084-7.57 8.402-5.18 1.14-10.51-1.389-11.9-5.655z",
  fill: "url(#upx-banner_svg__paint23_linear_14813_51300)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1679.3-32.901c1.19-1.992 2.35-3.932 4.82-5.116 4.26-2.023 9.7-.822 12.16 2.68 2.77 3.984.58 6.673-1.71 9.479-1.59 1.96-3.23 3.976-3.27 6.53-.09 2.49 1.53 4.437 3.13 6.371 1.56 1.865 3.1 3.717 3.08 6.033-.03 2.274-1.53 4.086-3.05 5.915-1.59 1.919-3.19 3.857-3.14 6.372-.08 3.762 4.93 6.18 8.88 4.272 2.66-1.024 3.96-3.258 5.25-5.467 1.19-2.044 2.36-4.065 4.6-5.086 4.25-2.023 9.7-.822 12.16 2.68 2.46 3.501 1 7.98-3.26 10.003-2.19 1.077-4.91.904-7.65.73-2.97-.19-5.97-.382-8.38 1.005-2.81 1.385-4.2 3.71-5.59 6.021v.002c-.52.873-1.04 1.744-1.64 2.563-3.48 4.213-11.83 3.774-14.78-.713-2.73-3.931-.52-6.604 1.75-9.37 1.65-1.996 3.33-4.04 3.23-6.64 0-2.485-1.59-4.418-3.16-6.33-1.54-1.878-3.06-3.735-3.05-6.073.03-2.245 1.57-4.062 3.11-5.88 1.65-1.959 3.31-3.917 3.08-6.408-.27-3.853-4.85-6.052-8.88-4.27-2.66 1.023-3.96 3.257-5.24 5.466-1.19 2.043-2.37 4.065-4.6 5.086-4.26 2.022-9.7.821-12.16-2.68-2.46-3.502-1-7.98 3.26-10.004 2.19-1.077 4.9-.904 7.65-.729 2.96.19 5.96.381 8.38-1.005 2.6-1.391 3.83-3.44 5.02-5.438z",
  fill: "url(#upx-banner_svg__paint24_linear_14813_51300)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M1755.83 54.52c-2.2-1.822-2.75-4.137-3.33-6.514-.57-2.384-1.16-4.83-3.43-6.902-2.07-2.023-5.3-2.518-8.49-3.008-2.95-.453-5.87-.902-7.82-2.547-3.79-3.123-3.79-8.185 0-11.305 3.8-3.121 9.95-3.122 13.75 0 2 1.596 2.55 4 3.1 6.432.59 2.628 1.2 5.286 3.65 6.984 3.64 2.813 9.22 1.56 10.83-2.44 1.09-2.574.02-5.024-1.05-7.473-1-2.274-1.99-4.548-1.25-6.922.78-2.47 3.03-4.073 5.3-5.695 2.31-1.65 4.65-3.32 5.51-5.94.99-2.719-.08-5.265-1.13-7.752-1.45-3.447-2.86-6.777 1.37-10.287 4.65-4.045 13.6-2.569 15.83 2.683.35 1.003.6 2.044.85 3.087.66 2.76 1.33 5.533 3.82 7.647 2.07 2.022 5.3 2.518 8.49 3.008 2.95.454 5.88.902 7.82 2.547 3.79 3.123 3.79 8.185 0 11.305-3.8 3.121-9.95 3.122-13.75 0-2-1.596-2.54-4-3.1-6.432-.59-2.628-1.2-5.286-3.65-6.984-3.51-2.931-9.63-1.547-10.83 2.44-.92 2.639.1 5.056 1.12 7.45.97 2.28 1.93 4.54 1.19 6.945-.78 2.445-3.04 4.04-5.32 5.645-2.36 1.666-4.74 3.342-5.49 5.99-.84 2.702.2 5.21 1.21 7.647 1.44 3.49 2.83 6.834-1.46 10.392-3.79 3.12-9.95 3.122-13.74-.001z",
  fill: "url(#upx-banner_svg__paint25_linear_14813_51300)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M1805.76 55.99c.58 2.377 1.13 4.693 3.33 6.514 3.8 3.123 9.95 3.122 13.74.001 4.29-3.558 2.9-6.902 1.46-10.392-1.01-2.437-2.05-4.945-1.21-7.646.75-2.648 3.13-4.325 5.49-5.99 2.28-1.606 4.54-3.2 5.32-5.646.75-2.405-.22-4.664-1.19-6.945-1.01-2.393-2.04-4.811-1.12-7.45 1.2-3.986 7.32-5.37 10.83-2.44 2.45 1.699 3.06 4.357 3.66 6.984.55 2.432 1.09 4.837 3.09 6.432 3.8 3.123 9.95 3.121 13.75 0 3.79-3.12 3.79-8.182 0-11.304-1.94-1.646-4.86-2.094-7.82-2.547-3.19-.49-6.42-.986-8.49-3.009-2.49-2.114-3.15-4.888-3.82-7.647-.25-1.043-.5-2.084-.85-3.086-2.22-5.252-11.18-6.729-15.83-2.683-4.23 3.51-2.82 6.84-1.37 10.287 1.05 2.486 2.12 5.033 1.13 7.751-.86 2.62-3.2 4.29-5.51 5.94-2.27 1.622-4.52 3.226-5.3 5.695-.74 2.374.26 4.648 1.25 6.923 1.07 2.449 2.15 4.898 1.05 7.473-1.61 3.999-7.19 5.253-10.82 2.44-2.46-1.699-3.06-4.357-3.66-6.985-.55-2.43-1.1-4.836-3.1-6.431-3.8-3.123-9.95-3.122-13.74-.001-3.8 3.12-3.8 8.183 0 11.305 1.94 1.646 4.86 2.094 7.81 2.547 3.19.49 6.43.986 8.49 3.009 2.27 2.072 2.86 4.517 3.43 6.901z",
  fill: "url(#upx-banner_svg__paint26_linear_14813_51300)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M1846.08 68.908c-.8-2.48.13-4.715 1.08-7.01.95-2.3 1.92-4.66 1.22-7.387-.56-2.603-3.06-4.361-5.53-6.1-2.28-1.606-4.54-3.196-5.22-5.42-1.39-4.265 1.69-8.65 6.87-9.79 5.19-1.142 10.51 1.388 11.9 5.654.77 2.205-.22 4.512-1.22 6.845-1.08 2.521-2.17 5.072-1.08 7.552 1.44 3.93 7.04 5.142 10.86 2.342 2.51-1.78 3.07-4.343 3.63-6.905.52-2.38 1.04-4.758 3.12-6.51 2.19-1.815 5.1-2.28 8.06-2.751 3-.479 6.04-.963 8.38-2.88 2.51-1.944 3.13-4.591 3.73-7.175.84-3.583 1.65-7.045 7.44-8.345 6.49-1.59 13.34 3.37 12.08 8.834-.31 1.011-.72 2.015-1.14 3.02v.004c-1.1 2.663-2.21 5.34-1.34 8.194.56 2.602 3.06 4.36 5.53 6.099 2.28 1.606 4.53 3.196 5.22 5.42 1.38 4.265-1.69 8.65-6.87 9.79-5.19 1.142-10.52-1.387-11.91-5.654-.76-2.204.23-4.512 1.23-6.845 1.08-2.521 2.17-5.071 1.08-7.552-1.26-3.983-7.4-5.3-10.86-2.342-2.41 1.906-2.99 4.423-3.56 6.914-.54 2.375-1.09 4.726-3.2 6.502-2.16 1.797-5.08 2.248-8.03 2.702-3.06.47-6.13.945-8.4 2.928-2.37 1.994-2.99 4.593-3.6 7.119-.87 3.618-1.7 7.084-7.57 8.402-5.19 1.14-10.51-1.389-11.9-5.655z",
  fill: "url(#upx-banner_svg__paint27_linear_14813_51300)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M1871.56-32.901c1.19-1.992 2.35-3.932 4.82-5.116 4.26-2.023 9.7-.822 12.16 2.68 2.77 3.984.58 6.673-1.71 9.479-1.59 1.96-3.23 3.976-3.27 6.53-.09 2.49 1.53 4.437 3.14 6.371 1.55 1.865 3.09 3.717 3.07 6.033-.03 2.274-1.53 4.086-3.05 5.915-1.59 1.919-3.19 3.857-3.14 6.372-.08 3.762 4.93 6.18 8.88 4.272 2.66-1.024 3.96-3.258 5.25-5.467 1.19-2.044 2.37-4.065 4.6-5.086 4.26-2.023 9.7-.822 12.16 2.68 2.46 3.501 1 7.98-3.26 10.003-2.19 1.077-4.91.904-7.65.73-2.97-.19-5.97-.382-8.38 1.005-2.81 1.385-4.2 3.71-5.59 6.021v.002c-.52.873-1.04 1.744-1.64 2.563-3.48 4.213-11.83 3.774-14.78-.713-2.73-3.931-.52-6.604 1.75-9.37 1.65-1.996 3.33-4.04 3.23-6.64 0-2.485-1.59-4.418-3.15-6.33-1.55-1.878-3.07-3.735-3.06-6.073.03-2.245 1.57-4.062 3.11-5.88 1.65-1.959 3.31-3.917 3.08-6.408-.27-3.853-4.85-6.052-8.88-4.27-2.66 1.023-3.96 3.257-5.24 5.466-1.19 2.043-2.37 4.065-4.6 5.086-4.26 2.022-9.7.821-12.16-2.68-2.46-3.502-1-7.98 3.26-10.004 2.19-1.077 4.9-.904 7.65-.729 2.96.19 5.96.381 8.38-1.005 2.6-1.391 3.83-3.44 5.02-5.438z",
  fill: "url(#upx-banner_svg__paint28_linear_14813_51300)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M25.909 62.52c-2.195-1.822-2.752-4.137-3.324-6.515-.574-2.383-1.163-4.829-3.431-6.9-2.069-2.024-5.3-2.52-8.493-3.01-2.952-.453-5.873-.9-7.815-2.546-3.794-3.123-3.796-8.185 0-11.306 3.795-3.12 9.947-3.122 13.744.001 2.001 1.595 2.547 4 3.1 6.432.596 2.627 1.2 5.286 3.655 6.984 3.632 2.813 9.217 1.56 10.83-2.44 1.091-2.575.019-5.024-1.054-7.473-.996-2.275-1.991-4.549-1.253-6.922.787-2.47 3.032-4.073 5.303-5.696 2.31-1.65 4.648-3.32 5.506-5.94.995-2.718-.078-5.265-1.126-7.75C40.097 5.99 38.693 2.66 42.922-.85c4.651-4.046 13.603-2.569 15.828 2.683.349 1.002.6 2.043.851 3.086.665 2.76 1.334 5.534 3.82 7.647 2.069 2.023 5.3 2.519 8.493 3.01 2.952.452 5.873.9 7.814 2.546 3.795 3.122 3.797 8.184.001 11.305-3.795 3.12-9.947 3.122-13.744 0-2.001-1.596-2.547-4-3.1-6.432-.596-2.628-1.2-5.286-3.655-6.984-3.511-2.931-9.63-1.547-10.83 2.44-.922 2.638.106 5.056 1.124 7.45.97 2.28 1.931 4.539 1.183 6.945-.779 2.445-3.04 4.04-5.316 5.645-2.361 1.666-4.738 3.342-5.493 5.99-.84 2.702.2 5.21 1.21 7.646 1.446 3.49 2.831 6.835-1.455 10.392-3.795 3.121-9.947 3.123-13.744 0z",
  fill: "url(#upx-banner_svg__paint29_linear_14813_51300)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M75.845 63.99c.572 2.377 1.13 4.693 3.324 6.514 3.797 3.123 9.95 3.122 13.745 0 4.286-3.557 2.9-6.9 1.454-10.391-1.01-2.437-2.05-4.945-1.21-7.647.755-2.648 3.132-4.324 5.493-5.99 2.276-1.605 4.537-3.2 5.316-5.645.749-2.406-.212-4.664-1.182-6.945-1.018-2.393-2.047-4.811-1.124-7.45 1.199-3.987 7.318-5.371 10.829-2.44 2.455 1.698 3.059 4.356 3.656 6.984.552 2.431 1.098 4.837 3.099 6.432 3.797 3.123 9.949 3.121 13.745 0 3.795-3.12 3.793-8.182-.001-11.305-1.942-1.645-4.862-2.093-7.815-2.546-3.193-.49-6.424-.986-8.492-3.01-2.486-2.113-3.155-4.887-3.821-7.646-.251-1.043-.502-2.084-.85-3.087-2.225-5.252-11.177-6.728-15.829-2.683-4.228 3.51-2.824 6.84-1.37 10.288 1.047 2.486 2.12 5.033 1.125 7.751-.857 2.62-3.195 4.29-5.505 5.94-2.272 1.622-4.517 3.226-5.303 5.695-.739 2.374.257 4.648 1.253 6.922 1.072 2.45 2.145 4.899 1.053 7.473-1.613 4-7.198 5.253-10.83 2.44-2.455-1.698-3.058-4.356-3.655-6.984-.552-2.431-1.099-4.836-3.1-6.431-3.797-3.123-9.948-3.122-13.744-.001-3.795 3.12-3.794 8.183 0 11.305 1.942 1.645 4.863 2.094 7.816 2.547 3.193.49 6.424.986 8.492 3.008 2.269 2.072 2.857 4.518 3.431 6.902z",
  fill: "url(#upx-banner_svg__paint30_linear_14813_51300)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M116.158 76.908c-.793-2.48.131-4.715 1.08-7.01.952-2.3 1.928-4.66 1.223-7.388-.562-2.602-3.058-4.36-5.526-6.099-2.282-1.607-4.539-3.196-5.22-5.42-1.389-4.265 1.686-8.65 6.87-9.79 5.183-1.142 10.511 1.387 11.902 5.654.763 2.204-.225 4.512-1.224 6.845-1.081 2.52-2.173 5.071-1.079 7.552 1.436 3.93 7.034 5.142 10.861 2.342 2.51-1.78 3.07-4.343 3.63-6.905.519-2.38 1.039-4.759 3.121-6.51 2.182-1.815 5.101-2.28 8.054-2.751 3.004-.48 6.043-.963 8.378-2.88 2.514-1.944 3.132-4.591 3.735-7.176.836-3.583 1.645-7.045 7.44-8.345 6.486-1.59 13.342 3.372 12.077 8.835-.308 1.012-.723 2.016-1.139 3.023-1.101 2.664-2.207 5.341-1.339 8.194.562 2.603 3.058 4.361 5.526 6.1 2.282 1.606 4.539 3.196 5.22 5.42 1.389 4.265-1.686 8.65-6.87 9.79-5.183 1.142-10.512-1.388-11.902-5.654-.764-2.205.225-4.512 1.224-6.845 1.081-2.521 2.173-5.072 1.079-7.552-1.259-3.983-7.4-5.301-10.861-2.342-2.403 1.906-2.982 4.423-3.554 6.914-.546 2.375-1.087 4.726-3.197 6.501-2.161 1.797-5.088 2.248-8.035 2.703-3.057.47-6.134.945-8.397 2.927-2.369 1.994-2.994 4.594-3.6 7.12-.868 3.617-1.701 7.084-7.575 8.401-5.183 1.142-10.512-1.388-11.902-5.654z",
  fill: "url(#upx-banner_svg__paint31_linear_14813_51300)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M141.643-24.902c1.192-1.992 2.352-3.932 4.819-5.115 4.259-2.023 9.702-.822 12.161 2.68 2.768 3.984.578 6.672-1.708 9.479-1.596 1.959-3.238 3.975-3.273 6.53-.095 2.49 1.525 4.437 3.134 6.371 1.551 1.865 3.092 3.717 3.077 6.033-.031 2.274-1.532 4.085-3.048 5.914-1.59 1.92-3.197 3.858-3.141 6.373-.088 3.762 4.928 6.18 8.879 4.271 2.662-1.023 3.962-3.258 5.247-5.466 1.189-2.044 2.366-4.066 4.596-5.087 4.26-2.022 9.703-.821 12.162 2.68 2.459 3.502.999 7.981-3.259 10.004-2.192 1.077-4.905.904-7.648.729-2.967-.19-5.969-.38-8.382 1.006-2.809 1.385-4.2 3.709-5.584 6.02-.523.875-1.045 1.747-1.642 2.566-3.482 4.213-11.829 3.773-14.779-.714-2.73-3.93-.528-6.603 1.751-9.37 1.644-1.995 3.328-4.04 3.231-6.639-.004-2.485-1.591-4.419-3.16-6.33-1.542-1.878-3.067-3.735-3.051-6.073.03-2.245 1.567-4.063 3.103-5.881 1.655-1.958 3.31-3.916 3.086-6.407-.275-3.853-4.855-6.052-8.879-4.271-2.662 1.023-3.962 3.258-5.248 5.466-1.189 2.044-2.365 4.066-4.596 5.087-4.259 2.022-9.702.821-12.161-2.68-2.459-3.502-.999-7.981 3.258-10.004 2.192-1.077 4.906-.904 7.649-.729 2.967.19 5.968.38 8.381-1.006 2.605-1.39 3.831-3.44 5.025-5.437z",
  fill: "url(#upx-banner_svg__paint32_linear_14813_51300)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M217.732 54.52c-2.195-1.822-2.752-4.137-3.324-6.515-.574-2.383-1.163-4.829-3.432-6.9-2.068-2.024-5.298-2.52-8.492-3.01-2.952-.453-5.873-.9-7.815-2.546-3.794-3.123-3.796-8.185 0-11.306 3.795-3.12 9.947-3.122 13.744.001 2.001 1.595 2.547 4 3.099 6.432.597 2.628 1.201 5.286 3.656 6.984 3.632 2.813 9.216 1.56 10.829-2.44 1.092-2.575.02-5.024-1.053-7.473-.996-2.274-1.992-4.549-1.253-6.922.787-2.47 3.032-4.073 5.303-5.696 2.311-1.65 4.648-3.32 5.506-5.94.995-2.718-.078-5.265-1.126-7.75-1.454-3.448-2.858-6.778 1.371-10.288 4.651-4.046 13.603-2.569 15.828 2.683.348 1.002.599 2.043.851 3.086.665 2.76 1.334 5.534 3.82 7.647 2.069 2.023 5.299 2.519 8.493 3.01 2.952.452 5.873.9 7.814 2.546 3.795 3.122 3.797 8.185.001 11.305-3.795 3.12-9.947 3.122-13.744 0-2.001-1.596-2.547-4-3.1-6.432-.596-2.628-1.2-5.286-3.656-6.984-3.51-2.931-9.629-1.547-10.829 2.44-.922 2.638.106 5.056 1.124 7.45.971 2.28 1.931 4.539 1.183 6.945-.779 2.445-3.04 4.04-5.316 5.645-2.361 1.666-4.738 3.342-5.493 5.99-.84 2.702.199 5.21 1.209 7.646 1.446 3.49 2.832 6.835-1.454 10.392-3.795 3.121-9.947 3.123-13.744 0z",
  fill: "url(#upx-banner_svg__paint33_linear_14813_51300)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M267.669 55.99c.572 2.377 1.13 4.692 3.324 6.514 3.797 3.123 9.949 3.122 13.744 0 4.287-3.557 2.901-6.9 1.454-10.391-1.009-2.437-2.049-4.945-1.208-7.647.754-2.648 3.131-4.324 5.492-5.99 2.276-1.605 4.537-3.2 5.316-5.645.749-2.406-.212-4.664-1.182-6.945-1.018-2.393-2.047-4.811-1.124-7.45 1.199-3.987 7.318-5.371 10.829-2.44 2.455 1.698 3.059 4.356 3.656 6.984.552 2.431 1.098 4.837 3.099 6.432 3.797 3.123 9.949 3.121 13.745 0 3.795-3.12 3.793-8.182-.001-11.305-1.942-1.645-4.862-2.093-7.815-2.546-3.193-.49-6.424-.986-8.492-3.01-2.486-2.113-3.155-4.887-3.821-7.646v-.001c-.251-1.043-.502-2.084-.851-3.086-2.224-5.252-11.176-6.728-15.828-2.683-4.228 3.51-2.824 6.84-1.371 10.288 1.048 2.486 2.122 5.033 1.126 7.751-.857 2.62-3.195 4.29-5.505 5.94-2.272 1.622-4.517 3.226-5.303 5.695-.739 2.374.257 4.648 1.253 6.922 1.072 2.45 2.145 4.899 1.053 7.473-1.613 4-7.198 5.253-10.829 2.44-2.456-1.698-3.059-4.356-3.656-6.984-.552-2.431-1.099-4.836-3.1-6.431-3.797-3.123-9.948-3.122-13.744-.001-3.795 3.12-3.794 8.183.001 11.305 1.941 1.645 4.862 2.094 7.815 2.547 3.193.49 6.424.986 8.492 3.008 2.269 2.072 2.857 4.518 3.431 6.902z",
  fill: "url(#upx-banner_svg__paint34_linear_14813_51300)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M307.981 68.908c-.794-2.48.131-4.715 1.08-7.01.952-2.3 1.928-4.66 1.223-7.388-.562-2.602-3.059-4.36-5.526-6.099-2.282-1.607-4.539-3.196-5.22-5.42-1.389-4.265 1.686-8.65 6.869-9.79 5.184-1.142 10.512 1.387 11.903 5.654.763 2.204-.225 4.512-1.225 6.845-1.08 2.521-2.172 5.071-1.078 7.552 1.435 3.93 7.034 5.142 10.861 2.342 2.51-1.78 3.07-4.343 3.63-6.905.519-2.38 1.039-4.759 3.121-6.51 2.182-1.815 5.101-2.28 8.054-2.751 3.004-.48 6.043-.963 8.378-2.88 2.514-1.944 3.132-4.591 3.735-7.176.836-3.583 1.644-7.045 7.44-8.345 6.486-1.59 13.342 3.372 12.077 8.835-.308 1.012-.723 2.016-1.139 3.023-1.101 2.664-2.208 5.341-1.339 8.194.562 2.603 3.058 4.361 5.526 6.1 2.282 1.606 4.539 3.196 5.22 5.42 1.389 4.265-1.686 8.65-6.87 9.79-5.183 1.142-10.512-1.388-11.902-5.654-.764-2.205.225-4.512 1.224-6.845 1.08-2.521 2.173-5.072 1.079-7.552-1.259-3.983-7.4-5.301-10.861-2.342-2.403 1.906-2.982 4.423-3.555 6.914-.545 2.375-1.086 4.726-3.196 6.501-2.161 1.797-5.088 2.248-8.035 2.703-3.057.47-6.134.945-8.397 2.927-2.37 1.994-2.994 4.594-3.6 7.12-.869 3.617-1.701 7.084-7.575 8.401-5.183 1.142-10.512-1.388-11.902-5.654z",
  fill: "url(#upx-banner_svg__paint35_linear_14813_51300)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M410.988 54.52c-2.194-1.822-2.752-4.137-3.324-6.515-.574-2.383-1.162-4.829-3.431-6.9-2.068-2.024-5.299-2.52-8.492-3.01-2.953-.453-5.874-.9-7.815-2.546-3.795-3.123-3.796-8.185-.001-11.306 3.796-3.12 9.947-3.122 13.744.001 2.001 1.595 2.548 4 3.1 6.432.597 2.628 1.2 5.286 3.656 6.984 3.631 2.813 9.216 1.56 10.829-2.44 1.092-2.575.019-5.024-1.053-7.473-.996-2.274-1.992-4.549-1.254-6.922.787-2.47 3.032-4.073 5.304-5.696 2.31-1.65 4.648-3.32 5.505-5.94.996-2.718-.078-5.265-1.126-7.75-1.453-3.448-2.857-6.778 1.371-10.288 4.652-4.046 13.604-2.569 15.828 2.683.349 1.002.6 2.043.851 3.085v.001c.666 2.76 1.334 5.534 3.821 7.647 2.068 2.023 5.298 2.519 8.492 3.01 2.952.452 5.873.9 7.815 2.546 3.794 3.122 3.796 8.185 0 11.305-3.795 3.12-9.947 3.122-13.744 0-2.001-1.596-2.547-4-3.099-6.432-.597-2.628-1.201-5.286-3.656-6.984-3.511-2.931-9.63-1.547-10.829 2.44-.923 2.638.106 5.056 1.124 7.45.97 2.28 1.931 4.539 1.182 6.945-.779 2.445-3.04 4.04-5.316 5.645-2.361 1.666-4.738 3.342-5.492 5.99-.841 2.702.199 5.21 1.208 7.646 1.447 3.49 2.833 6.835-1.454 10.392-3.795 3.121-9.947 3.123-13.744 0z",
  fill: "url(#upx-banner_svg__paint36_linear_14813_51300)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M460.927 55.99c.572 2.377 1.129 4.692 3.324 6.514 3.797 3.123 9.948 3.122 13.744 0 4.286-3.557 2.9-6.9 1.454-10.391-1.01-2.437-2.049-4.945-1.209-7.647.755-2.648 3.132-4.324 5.492-5.99 2.277-1.605 4.538-3.2 5.317-5.645.748-2.406-.212-4.664-1.183-6.945-1.018-2.393-2.046-4.811-1.124-7.45 1.2-3.987 7.319-5.371 10.829-2.44 2.456 1.698 3.059 4.356 3.656 6.984.552 2.431 1.099 4.837 3.1 6.432 3.797 3.123 9.949 3.121 13.744 0 3.795-3.12 3.794-8.182-.001-11.305-1.941-1.645-4.862-2.093-7.814-2.546-3.194-.49-6.425-.986-8.493-3.01-2.486-2.113-3.155-4.887-3.82-7.646v-.001c-.252-1.043-.503-2.084-.851-3.086-2.225-5.252-11.177-6.728-15.828-2.683-4.229 3.51-2.825 6.84-1.372 10.288 1.049 2.486 2.122 5.033 1.126 7.751-.857 2.62-3.194 4.29-5.505 5.94-2.271 1.622-4.517 3.226-5.303 5.695-.739 2.374.257 4.648 1.253 6.922 1.073 2.45 2.145 4.899 1.053 7.473-1.613 4-7.197 5.253-10.829 2.44-2.455-1.698-3.059-4.356-3.656-6.984-.552-2.431-1.098-4.836-3.099-6.431-3.797-3.123-9.949-3.122-13.744-.001-3.796 3.12-3.794 8.183 0 11.305 1.942 1.645 4.863 2.094 7.815 2.547 3.194.49 6.424.986 8.492 3.008 2.269 2.072 2.858 4.518 3.432 6.902z",
  fill: "url(#upx-banner_svg__paint37_linear_14813_51300)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M501.238 68.908c-.793-2.48.131-4.715 1.081-7.01.951-2.3 1.928-4.66 1.222-7.388-.562-2.602-3.058-4.36-5.526-6.099-2.281-1.607-4.539-3.196-5.22-5.42-1.388-4.265 1.687-8.65 6.87-9.79 5.183-1.142 10.512 1.387 11.902 5.654.764 2.204-.225 4.512-1.224 6.845-1.08 2.521-2.173 5.071-1.078 7.552 1.435 3.93 7.033 5.142 10.86 2.342 2.511-1.78 3.07-4.343 3.63-6.905.52-2.38 1.039-4.759 3.122-6.51 2.181-1.815 5.1-2.28 8.054-2.751 3.003-.48 6.043-.963 8.377-2.88 2.514-1.944 3.132-4.591 3.736-7.176.836-3.583 1.644-7.045 7.439-8.345 6.487-1.59 13.342 3.372 12.077 8.835-.307 1.011-.722 2.016-1.138 3.022-1.101 2.664-2.208 5.342-1.339 8.195.561 2.603 3.058 4.361 5.526 6.1 2.281 1.606 4.538 3.196 5.22 5.42 1.388 4.265-1.687 8.65-6.87 9.79-5.184 1.142-10.512-1.388-11.902-5.654-.764-2.205.224-4.512 1.224-6.845 1.08-2.521 2.172-5.072 1.078-7.552-1.259-3.983-7.399-5.301-10.861-2.342-2.403 1.906-2.981 4.423-3.554 6.914-.546 2.375-1.087 4.726-3.197 6.501-2.16 1.797-5.088 2.248-8.035 2.703-3.056.47-6.134.945-8.396 2.927-2.37 1.994-2.994 4.594-3.601 7.12-.868 3.617-1.7 7.084-7.574 8.401-5.184 1.142-10.512-1.388-11.903-5.654z",
  fill: "url(#upx-banner_svg__paint38_linear_14813_51300)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M526.724-32.902c1.192-1.992 2.352-3.932 4.819-5.115 4.26-2.023 9.703-.822 12.162 2.68 2.767 3.984.577 6.673-1.708 9.479-1.596 1.959-3.239 3.975-3.274 6.53-.095 2.49 1.525 4.437 3.134 6.371 1.552 1.865 3.093 3.717 3.077 6.033-.031 2.274-1.532 4.085-3.048 5.914-1.59 1.92-3.197 3.858-3.141 6.373-.087 3.762 4.928 6.18 8.879 4.271 2.662-1.023 3.962-3.258 5.248-5.466 1.189-2.044 2.365-4.066 4.596-5.087 4.259-2.022 9.702-.821 12.161 2.68 2.459 3.502.999 7.981-3.258 10.004-2.192 1.077-4.906.904-7.649.729-2.967-.19-5.968-.38-8.381 1.006-2.809 1.385-4.2 3.709-5.584 6.02-.524.875-1.046 1.747-1.643 2.566-3.482 4.213-11.828 3.773-14.778-.714-2.731-3.93-.528-6.603 1.751-9.37 1.644-1.995 3.328-4.04 3.23-6.639-.004-2.485-1.591-4.419-3.16-6.33-1.542-1.878-3.067-3.735-3.051-6.073.031-2.245 1.567-4.063 3.104-5.881 1.654-1.958 3.309-3.916 3.085-6.407-.275-3.853-4.855-6.052-8.879-4.271-2.662 1.023-3.962 3.258-5.247 5.466-1.19 2.044-2.366 4.066-4.596 5.087-4.26 2.022-9.703.821-12.162-2.68-2.459-3.502-.999-7.981 3.259-10.004 2.192-1.077 4.905-.904 7.648-.729 2.967.19 5.969.38 8.382-1.006 2.604-1.39 3.83-3.44 5.024-5.437z",
  fill: "url(#upx-banner_svg__paint39_linear_14813_51300)"
});

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint0_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint1_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint2_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint3_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint4_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint5_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint6_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint7_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint8_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint9_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint10_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint11_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint12_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint13_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint14_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint15_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint16_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint17_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint18_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint19_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint20_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint21_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint22_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint23_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint24_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint25_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint26_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint27_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint28_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint29_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint30_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint31_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint32_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint33_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint34_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint35_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint36_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint37_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint38_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "upx-banner_svg__paint39_linear_14813_51300",
  x1: 0,
  y1: 21.918,
  x2: 1920,
  y2: 21.918,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F6F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.371,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.619,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5F6F6"
})));

function SvgUpxBanner(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
}

export default SvgUpxBanner;